module.exports = __webpack_public_path__ + "media/adult.cec25934.wav";